import * as tslib_1 from "tslib";
import { env } from '@ivy/fts/envInfo/envInfo';
import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import DelConfirm from './delConfirm.vue';
import * as goodsApi from '@/api/goods';
import showDiv from '@ivy/fts/showDiv';
let GoodsInfo = class GoodsInfo extends Vue {
    constructor() {
        super(...arguments);
        this.isConfirmShow = false;
        this.posInfo = {
            contw: 0,
            initx: 0,
            translateX: 0,
            moveScale: 0,
            show: false,
            style: { transform: `translateX(0)` },
        };
        this.timer = null;
        this.limitBuyTime = '';
    }
    get isDisable() {
        return (!this.goodsInfo.is_sale ||
            !this.goodsInfo.stock_status ||
            !this.goodsInfo.sku_status);
    }
    get disableReason() {
        if (!this.goodsInfo.sku_status)
            return '已下架';
        if (!this.goodsInfo.stock_status)
            return '已售罄';
        if (!this.goodsInfo.is_sale)
            return '购物车暂不支持结算此类活动';
        return '';
    }
    get giftsFilter() {
        let gift_list = (this.goodsInfo.activity_info &&
            this.goodsInfo.activity_info.gift_activity &&
            this.goodsInfo.activity_info.gift_activity.gift_list) ||
            [];
        return gift_list;
    }
    startCountDonwn() {
        let limit_buy = (this.goodsInfo.activity_info &&
            this.goodsInfo.activity_info.limit_buy_activity) ||
            {};
        if (limit_buy.end_time) {
            this.countDownHandle(limit_buy.end_time);
        }
        else {
            clearInterval(this.timer);
            this.limitBuyTime = '';
        }
    }
    initDel(v) {
        this.posInfo = {
            contw: 0,
            initx: 0,
            translateX: 0,
            moveScale: 0,
            show: false,
            style: {
                transform: `translateX(0)`,
            },
        };
    }
    created() {
        console.log(this.isVip);
    }
    // 跳转商详页
    async toGoodsView() {
        if (!this.goodsInfo.stock_status || !this.goodsInfo.sku_status)
            return;
        let { data: { data: cartData }, } = await goodsApi.getCartData();
        let now_sku_info = cartData &&
            cartData.product_info &&
            cartData.product_info.find(el => el.spu_id === this.goodsInfo.spu_id);
        if (now_sku_info && now_sku_info.sku_status === 0) {
            this.$Toast('该商品已下架');
            this.$emit('updateData', cartData);
        }
        else {
            await env.init();
            this.$router.push({
                path: '/goodsview',
                query: {
                    spuId: this.goodsInfo.spu_id,
                    navBarHide: '1',
                },
            });
        }
    }
    // 展示礼物弹窗
    showGiftsPop() {
        if (this.isDisable)
            return;
        this.$emit('showGiftsPop', this.giftsFilter, +this.goodsInfo.num);
    }
    // 删除确认
    async confirmDel() {
        let res = await showDiv(DelConfirm, { goodsInfo: this.goodsInfo });
        if (res) {
            const { data: { data: cartData }, } = await goodsApi.saveCart({
                type: 2,
                sku_id: this.goodsInfo.sku_id,
                num: this.goodsInfo.num,
            });
            this.$Toast('删除成功');
            this.$emit('updateData', cartData);
        }
    }
    // 更改商品规格
    showChangeAttr() {
        if (this.isDisable)
            return;
        this.$emit('showChangeAttr', {
            spu_id: this.goodsInfo.spu_id,
            sku_id: this.goodsInfo.sku_id,
        });
    }
    // 修改商品数量
    async changeNum(type) {
        if (this.isDisable)
            return;
        let num;
        switch (type) {
            case 'sub':
                num = this.goodsInfo.num - 1;
                break;
            case 'add':
                num = this.goodsInfo.num + 1;
        }
        if (num < 1) {
            return this.$Toast('不能再减啦，商品至少购买一件');
        }
        if (num > 200) {
            return this.$Toast('不能再加啦，商品最多添加200件');
        }
        const { data: { data: cartData }, } = await goodsApi.saveCart({
            type: 1,
            sku_id: this.goodsInfo.sku_id,
            num: num,
        });
        this.checkStatus(cartData);
        this.$emit('updateData', cartData);
    }
    // 选择商品 选中 3 ; 取消 4
    async checkGood() {
        if (this.isDisable)
            return;
        const { data: { data: cartData }, } = await goodsApi.saveCart({
            type: this.goodsInfo.is_check ? 4 : 3,
            sku_id: this.goodsInfo.sku_id,
            num: this.goodsInfo.num,
        });
        this.checkStatus(cartData);
        this.$emit('updateData', cartData);
    }
    checkStatus(cartData) {
        let now_sku_info = cartData &&
            cartData.product_info &&
            cartData.product_info.find(el => el.sku_id === this.goodsInfo.sku_id);
        if (now_sku_info && now_sku_info.sku_status === 0) {
            this.$Toast('商品已下架');
        }
        else if (now_sku_info && now_sku_info.stock_status === 0) {
            this.$Toast('商品已售罄');
        }
        else if (now_sku_info && now_sku_info.is_sale === 0) {
            this.$Toast('商品已失效');
        }
    }
    // 滑动触发删除按钮 *先写出效果 有时间再优化*
    touchstart(e) {
        let cont = this.$refs.cartItem;
        this.posInfo.contw = cont.offsetWidth;
        this.posInfo.initx = e.targetTouches[0].pageX;
    }
    touchmove(e) {
        // 移动的距离
        let distance = this.posInfo.initx - e.targetTouches[0].pageX;
        this.posInfo.translateX = distance;
        // 触发展示条件的百分比
        let moveScale = ((distance / this.posInfo.contw) * (702 / 88)) / 3;
        if (Math.abs(moveScale) > 1) {
            moveScale = Math.abs(moveScale) / moveScale;
        }
        this.posInfo.moveScale = moveScale;
        if (!this.posInfo.show) {
            this.posInfo.style = {
                transform: `translateX(-${moveScale *
                    88 *
                    (this.posInfo.contw / 702)}px)`,
            };
        }
        if (this.posInfo.show && moveScale < 0) {
            this.posInfo.style = {
                transform: `translateX(-${88 * (this.posInfo.contw / 702) +
                    moveScale * 88 * (this.posInfo.contw / 702)}px)`,
            };
        }
    }
    touchend(e) {
        // 如果没展示 且移动距离满足要求
        if (!this.posInfo.show && this.posInfo.moveScale > 0.6) {
            this.posInfo.show = true;
        }
        if (this.posInfo.show && this.posInfo.moveScale < -0.6) {
            this.posInfo.show = false;
        }
        if (this.posInfo.show) {
            this.posInfo.style = {
                transform: `translateX(-${88 * (this.posInfo.contw / 702)}px)`,
            };
        }
        else {
            this.posInfo.style = { transform: `translateX(0px)` };
        }
    }
    // 倒计时函数
    countDownHandle(end) {
        let endTime = +new Date(end.replace(/-/g, '/'));
        let nowTime = +new Date();
        if (endTime <= nowTime)
            return;
        let leftTime = (endTime - nowTime) / 1000;
        let that = this;
        function getTime(leftTime) {
            let day = Math.floor(leftTime / 60 / 60 / 24);
            let hour = Math.floor((leftTime / 60 / 60) % 24);
            hour = hour < 10 ? '0' + hour : hour;
            let minute = Math.floor((leftTime / 60) % 60);
            minute = minute < 10 ? '0' + minute : minute;
            let second = Math.floor(leftTime % 60);
            second = second < 10 ? '0' + second : second;
            that.limitBuyTime = `${day}天${hour}小时${minute}分${second}秒`;
        }
        getTime(leftTime);
        if (this.timer) {
            clearInterval(this.timer);
        }
        this.timer = setInterval(async () => {
            leftTime -= 1;
            if (leftTime <= 0) {
                clearInterval(this.timer);
                this.limitBuyTime = '';
                let { data: { data: cartData }, } = await goodsApi.getCartData();
                this.$emit('updateData', cartData);
                return;
            }
            getTime(leftTime);
        }, 1000);
    }
};
tslib_1.__decorate([
    Prop()
], GoodsInfo.prototype, "goodsInfo", void 0);
tslib_1.__decorate([
    Prop()
], GoodsInfo.prototype, "isVip", void 0);
tslib_1.__decorate([
    Watch('goodsInfo.activity_info', { immediate: true, deep: true })
], GoodsInfo.prototype, "startCountDonwn", null);
tslib_1.__decorate([
    Watch('goodsInfo', { immediate: true })
], GoodsInfo.prototype, "initDel", null);
GoodsInfo = tslib_1.__decorate([
    Component
], GoodsInfo);
export default GoodsInfo;
